import * as React from "react";
import {default as appStoreImageUrl} from "resources/store-links/app-store-image-en.png";
import {default as playStoreImageUrl} from "resources/store-links/play-store-image-en.png";

type PlatformDetails = {
	platformName: string
	platformImageUrl: string
	appLink: string
}


const APP_STORE_DETAILS: Readonly<PlatformDetails> = {
	platformName: "App Store",
	platformImageUrl: appStoreImageUrl,
	appLink: "https://itunes.apple.com/us/app/apple-store/id1588721133"
} satisfies PlatformDetails;


const PLAY_STORE_DETAILS: Readonly<PlatformDetails> = {
	platformName: "Play Store",
	platformImageUrl: playStoreImageUrl,
	appLink: "https://play.google.com/store/apps/details?id=com.cherri"
} satisfies PlatformDetails;


export function AppStoreLink() {
	return (
		<a
			href={APP_STORE_DETAILS.appLink}
			target="_blank" rel="noopener noreferrer"
			className="inline-block"
		>
			<img
				src={APP_STORE_DETAILS.platformImageUrl}
				alt={`${APP_STORE_DETAILS.platformName} link`}
				className="w-[135px] h-[40px]"
			/>
		</a>
	);
}


export function PlayStoreLink() {
	return (
		<a
			href={PLAY_STORE_DETAILS.appLink}
			target="_blank" rel="noopener noreferrer"
			className="inline-block"
		>
			<img
				src={PLAY_STORE_DETAILS.platformImageUrl}
				alt={`${PLAY_STORE_DETAILS.platformName} link`}
				className="w-[135px] h-[40px]"
			/>
		</a>
	);
}
